/** @jsx jsx */

import { Fragment, ReactNode } from 'react';
import { jsx, css } from '@emotion/core';
import { Colors, Text } from '@zapier/design-system';

const Styles = {
  root: css`
    :not(:last-of-type) {
      margin-bottom: 30px;
    }
  `,
  fieldLabel: css`
    margin-bottom: 15px;
  `,
  inputTitle: ({ isRequired, isTitleOnly }) => [
    css`
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;

      ::after {
        content: '(optional)';
        color: ${Colors.GrayWarm4};
        font-size: 11px;
        margin: 0px 5px;
      }
    `,
    isRequired &&
      css`
        ::after {
          content: '(required)';
          color: ${Colors.Red4};
        }
      `,
    isTitleOnly &&
      css`
        ::after {
          content: '';
          margin: 0px;
        }
      `,
  ],
};

type Props = {
  title: string;
  children: ReactNode | ((props: { fieldLabel: ReactNode }) => ReactNode);
  className?: string;
  helpText?: string | ReactNode;
  inputTitleId?: string;
  required: boolean;
  isTitleOnly: boolean;
};

const NonFormaticFieldWrapper = (props: Props) => {
  const {
    title,
    children,
    className,
    helpText,
    inputTitleId,
    required,
    isTitleOnly,
  } = props;

  const fieldLabel = (
    <Fragment>
      <h3
        css={Styles.inputTitle({ isRequired: required, isTitleOnly })}
        id={inputTitleId}
      >
        {title}
      </h3>
      {!!helpText &&
        (typeof helpText === 'string' ? (
          <Text tag="div">
            <span dangerouslySetInnerHTML={{ __html: helpText }} />
          </Text>
        ) : (
          <Text tag="span">{helpText}</Text>
        ))}
    </Fragment>
  );

  return typeof children === 'function' ? (
    children({ fieldLabel })
  ) : (
    <div className={className || ''} css={Styles.root}>
      <div css={Styles.fieldLabel}>{fieldLabel}</div>
      {children}
    </div>
  );
};

NonFormaticFieldWrapper.defaultProps = {
  required: false,
  isTitleOnly: false,
};

export default NonFormaticFieldWrapper;
